import { useCallback } from 'react';
import { useFormikContext } from 'formik';
import { CheckoutFormValues } from '../../types/appointments';
import { customLine } from '../../utils/checkout/customLine';

/** Adds a line from what was typed in search: an amount, or a named custom item. */
function useAddCustomLine() {
  const { values, setFieldValue } = useFormikContext<CheckoutFormValues>();

  return useCallback(
    (query: string) =>
      setFieldValue('customOrderItems', [
        ...(values.customOrderItems ?? []),
        customLine(query, Date.now().toString()),
      ]),
    [values.customOrderItems, setFieldValue],
  );
}

export default useAddCustomLine;
